import { render, staticRenderFns } from "./parallax-test.vue?vue&type=template&id=b164a3d6&"
import script from "./parallax-test.vue?vue&type=script&lang=js&"
export * from "./parallax-test.vue?vue&type=script&lang=js&"
import style0 from "./parallax-test.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports